import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import RiskLevelBadge from "./risk-level-badge";
import { RiskAssessmentResult } from "./types/risk-search-response";

interface SearchResultsHeaderProps {
  result: RiskAssessmentResult | undefined;
  claimReference: string;
  searchOptionals: string[];
}

const SearchResultsHeader = ({
  result,
  claimReference,
  searchOptionals,
}: SearchResultsHeaderProps) => {
  return (
    <Box
      sx={{
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        padding: (theme) => theme.spacing(2),
        height: "auto",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          size={{ xs: 2 }}
          alignItems="start"
          display="flex"
          justifyContent="flex-start"
        >
          <RiskLevelBadge level={result} />
        </Grid>
        <Grid
          size={{ xs: 2 }}
          alignItems="start"
          display="flex"
          paddingTop="3px"
          justifyContent="flex-start"
        >
          <strong>{claimReference}</strong>
        </Grid>
        {searchOptionals.map((value) => (
          <Grid
            key={`search-option-${value}`}
            size={{ xs: "auto" }}
            paddingTop="3px"
            alignItems="start"
            display="flex"
            justifyContent="flex-start"
          >
            {value}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SearchResultsHeader;
